
import { defineComponent, onMounted, ref } from "vue";

import { IUser } from "@/types/auth";
import Header from "@/components/Header.vue";
import GoBack from "../components/Back.vue";
import { authService } from "@/services/auth";
import Loading from "@/components/Loading.vue";
import { toastError } from "@/utils/toastError";

export default defineComponent({
  name: "Users",
  components: {
    GoBack,
    Header,
    Loading,
  },

  setup() {
    const loading = ref(false);
    const users = ref<IUser[]>([]);

    const columns = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        align: "center",
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        align: "center",
      },
      {
        title: "Role",
        dataIndex: "role",
        key: "role",
        align: "center",
      },
    ];

    function fetchAllUsers() {
      loading.value = true;
      authService
        .getAllUsers()
        .then((data) => (users.value = data))
        .catch((err) => toastError(err))
        .finally(() => (loading.value = false));
    }
    onMounted(() => fetchAllUsers());

    return { users, loading, columns };
  },
});
